module.exports = __webpack_public_path__ + "static/media/21-mercedes.feddd89f.jpg";